import { useSelector, useDispatch } from "react-redux"; // Add useDispatch
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import api from "@/utils/api";
import { LogOut, User, Settings, Redo, RefreshCcw } from "lucide-react";
import { logout } from "@/store/slices/authSlice"; // Import the logout action
import { useNavigate } from "react-router-dom";
import { SidebarTrigger } from "@/components/ui/sidebar";

const Header = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch(); // Initialize dispatch
  const navigate = useNavigate();
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const handleLogout = async () => {
    const res = await api.post(`/logout`, { withCredentials: true });
    dispatch(logout()); // Dispatch the logout action
    navigate("/login");
  };

  const handleProfile = () => {
    navigate("/profile");
  };

  return (
    <header className="border-b w-[100%] bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-14 items-center px-6">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <SidebarTrigger />
            <h1 className="text-xl hidden lg:block font-semibold">Welcome {user?.name}</h1>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <Button
            variant="default"
            type="button"
            className="relative rounded-full"
            onClick={() => {
              window.location.reload(true);
            }}
          >
            <RefreshCcw className="text-white h-4 w-4" />
          </Button>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="relative h-8 w-8 rounded-full">
                <Avatar className="h-10 w-10">
                  <AvatarFallback>
                    {getInitials(user?.name || "User")}
                  </AvatarFallback>
                </Avatar>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56" align="end" forceMount>
              <DropdownMenuItem onClick={handleProfile}>
                <User className="mr-2 h-4 w-4" />
                <span>Profile</span>
              </DropdownMenuItem>
              <DropdownMenuItem>
                <Settings className="mr-2 h-4 w-4" />
                <span>Settings</span>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={handleLogout}>
                {" "}
                {/* Add onClick handler */}
                <LogOut className="mr-2 h-4 w-4" />
                <span>Log out</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
};

export default Header;
